import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { financialStatementService } from 'v2/services/financialStatement/statement';

import ValueCard from '../ValueCard';

function FutureCard() {
  const [loadingAvailableFuture, setLoadingAvailableFuture] = useState(true);
  const [availableFutureValue, setAvailableFutureValue] = useState(null);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const [loadAvailableFuture] = useCallbackObservable(() => {
    setLoadingAvailableFuture(true);

    return financialStatementService.getAvailableInFuture().pipe(
      tap(({ data }) => {
        setAvailableFutureValue(user?.crossborder ? data.total_origin : data.total);
        setLoadingAvailableFuture(false);
      }),
      catchError(error => {
        toast.error(error);
        setLoadingAvailableFuture(false);
        return of(true);
      })
    );
  }, []);

  useEffect(() => {
    loadAvailableFuture();
  }, [loadAvailableFuture]);

  return (
    <ValueCard
      id='future-card'
      title='Lançamentos futuros'
      isLoading={loadingAvailableFuture}
      value={availableFutureValue}
      hint='Faturas não consolidadas'
    />
  );
}

export default FutureCard;
